import type { ComponentProps } from 'react';
import { useTranslations } from 'next-intl';
import DailyBonusCard from '@/components/entities/dailyBonus/components/DailyBonusCard';

interface Props extends ComponentProps<typeof DailyBonusCard> {
  titleKey: string;
  subTitleKey: string;
}

export const DailyInfoCard = ({ titleKey, subTitleKey, ...card }: Props) => {
  const t = useTranslations('daily-bonus.information');
  return (
    <div className="flex items-center gap-3">
      <DailyBonusCard {...card} />
      <div>
        <p className="font-semibold text-base leading-[1.188rem] mb-1">{t(titleKey)}</p>
        <p className="font-normal text-base leading-6">{t.rich(subTitleKey, { br: () => <br /> })}</p>
      </div>
    </div>
  );
};
